import type { DynamicsConfig } from "../types/game-config";
import { magnitude } from "./vector";

interface MovingEntity {
  readonly vx: number;
  readonly vy: number;
}

export function applyFriction(
  vx: number,
  vy: number,
  config: DynamicsConfig,
): { readonly vx: number; readonly vy: number } {
  const speed = magnitude({ x: vx, y: vy });

  if (speed <= config.velocityThreshold) {
    return { vx: 0, vy: 0 };
  }

  const deceleration = config.frictionCoefficient * config.timeStep;
  const newSpeed = Math.max(0, speed - deceleration);

  if (newSpeed === 0) {
    return { vx: 0, vy: 0 };
  }

  const ratio = newSpeed / speed;
  return { vx: vx * ratio, vy: vy * ratio };
}

export function allEntitiesStopped(
  entities: ReadonlyArray<MovingEntity>,
  config: DynamicsConfig,
): boolean {
  return entities.every((entity) => {
    return (
      magnitude({ x: entity.vx, y: entity.vy }) <= config.velocityThreshold
    );
  });
}
